module.exports = __webpack_public_path__ + "static/media/lt_truck_start.55a8d411.png";